import * as z$1 from "zod/v4";
//#region src/schemas/space-mesh/publication-policy.ts
const spacePublicationModeSchema = z$1.enum(["collaboration", "raw_context_sharing"]);
const spaceAllowedActionSchema = z$1.enum([
	"post_message",
	"post_status",
	"stay_silent"
]);
const spaceAllowedActionsSchema = z$1.array(spaceAllowedActionSchema).superRefine((value, ctx) => {
	if (value.length === 0) {
		ctx.addIssue({
			code: "custom",
			message: "allowedActions must contain at least one action"
		});
		return;
	}
	if (new Set(value).size !== value.length) ctx.addIssue({
		code: "custom",
		message: "allowedActions must not contain duplicates"
	});
});
//#endregion
export { spaceAllowedActionSchema, spaceAllowedActionsSchema, spacePublicationModeSchema };

//# sourceMappingURL=publication-policy.js.map